const { Core, Events } = Global;

const CN_LOADING = '!loading';
const ATTR_VARIANT_ID = 'variant-id';

customElements.define('product-to-cart', class extends Core {
    elements = {
        $: ['to-cart-button']
    }

    propTypes = {
        'form-child': Boolean
    }

    render() {
        this.$({click: this._onClick});
        this.sub(Events.CART_UPDATE, this._cartUpdateHandler, { global: true });
        this.sub(Events.CART_ERROR, this._cartUpdateHandler, { global: true });
    }

    _onClick(e) {
        // Don't trigger add to cart if clicking on quantity input or its wrapper
        const quantityInput = this.querySelector('[name="quantity"]');
        const quickAddWrapper = this.querySelector('.\\#product-card-quick-add-wrapper, .product-card-quick-add-wrapper');
        
        if (quantityInput && (e.target === quantityInput || quantityInput.contains(e.target))) {
            return;
        }
        if (quickAddWrapper && quickAddWrapper.contains(e.target) && e.target !== this.$('to-cart-button') && !this.$('to-cart-button').contains(e.target)) {
            return;
        }
        
        !this.prop('form-child') && e.preventDefault();
        this.loading = true;
        !this.prop('form-child') && this.addToCart(this.cartItem);
    }

    addToCart(items) {
        this.pub(Events.CART_ADD, {
            items
        });
    }

    _cartUpdateHandler() {
        setTimeout(() => {
            this.loading = false
        }, 1500)
    }

    get cartItem() {
        return [{ 
            id: this.variantId,
            quantity: this.quantityValue
        }]
    }
    
    set loading(state) {
        this.$('to-cart-button').classList.toggle(CN_LOADING, state);
    }

    set variantId(id) {
        this.setAttribute(ATTR_VARIANT_ID, id)
    }
 
    get quantityValue() {
        if(this.querySelector('[name="quantity"]')){
          return +this.querySelector('[name="quantity"]').value;
        }else{
          return 1;
        }
    }
    get variantId() {
        return +this.getAttribute(ATTR_VARIANT_ID)
    }
})